/** "#Tittenhurst Park › Members" in the desktop header: the conversation
 *  name is a link back to it (closing Members, from the list or from add
 *  mode alike), the title is the page. */
export function MessagesMembersBreadcrumb({ context, title }: { context: string; title: string }) {
  return (
    <span className="flex min-w-0 items-baseline gap-1.5">
      <button
        type="button"
        onClick={() => window.dispatchEvent(new CustomEvent('messages:members:close'))}
        className="cursor-pointer truncate rounded-[4px] font-normal text-muted-foreground underline-offset-2 hover:text-foreground hover:underline focus-visible:underline focus-visible:outline-none"
      >
        {context}
      </button>
      <span aria-hidden="true" className="font-normal text-label-tertiary">›</span>
      <span className="truncate">{title}</span>
    </span>
  );
}
